import React from 'react'
import { Button } from '../ui/button'

interface TermsConfirmationModalProps {
  isOpen: boolean
  loading: boolean
  onConfirm: () => void
  onClose: () => void
}

export default function TermsConfirmationModal({
  isOpen,
  loading,
  onConfirm,
  onClose,
}: TermsConfirmationModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4">
        <div className="p-6">
          <div className="pb-4">
            <h3 className="text-xl font-bold text-gray-900 text-center">
              IMPORTANT
            </h3>
          </div>

          <div className="pb-6">
            <p className="text-gray-700 leading-relaxed">
              By selecting and then clicking on the{' '}
              <span className="text-green-600 font-semibold">I Agree</span>{' '}
              button I indicate I actually read the provisions in the Terms of
              Service, I fully understand its provisions, and I expressly agree
              to the provisions of the Terms of Service.
            </p>
          </div>

          <div className="flex justify-between space-x-3">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="px-4 py-2"
            >
              Go Back
            </Button>
            <Button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white"
            >
              {loading ? (
                <>
                  <i className="fa-duotone fa-solid fa-spinner-third fa-spin mr-2" />
                  Processing...
                </>
              ) : (
                'I Agree'
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
